/* =========================================
   HOURI – Variant pills highlight (FINAL)
   ========================================= */

(function () {

  /* ⬇️ EXACTEMENT les libellés à pousser */
  const featuredValues = [
    "conquiers",
    "déploie ta puissance"
  ];

  function applyFeaturedVariants(root = document) {
    const labels = root.querySelectorAll(
      '.product-form__input label'
    );

    labels.forEach(label => {
      const value = label.textContent
        .trim()
        .toLowerCase();

      if (featuredValues.includes(value)) {
        label.classList.add('variant-pill--featured');
      }
    });
  }

  /* Front */
  document.addEventListener('DOMContentLoaded', () => {
    applyFeaturedVariants();
  });

  /* Shopify editor (quand tu changes de section) */
  document.addEventListener('shopify:section:load', (e) => {
    applyFeaturedVariants(e.target);
  });

})();
